import React, { useState, useMemo } from 'react';
import Select from 'react-select';

const PAGINA_OPCOES = 50;

// Select para listas grandes: filtra client-side e carrega +50 opções conforme o
// usuário rola até o fim (onMenuScrollToBottom), sem travar ao renderizar milhares
// de itens de uma vez. A lista completa vem via prop `options`.
const SelectPaginado = ({ options, ...props }) => {
  const [busca, setBusca] = useState('');
  const [visiveis, setVisiveis] = useState(PAGINA_OPCOES);

  const filtradas = useMemo(() => {
    const lista = options || [];
    const termo = busca.trim().toLowerCase();
    return termo
      ? lista.filter((o) => (o.label || '').toLowerCase().includes(termo))
      : lista;
  }, [options, busca]);

  return (
    <Select
      {...props}
      options={filtradas.slice(0, visiveis)}
      filterOption={() => true}
      onInputChange={(valor, meta) => {
        if (meta.action === 'input-change') {
          setBusca(valor);
          setVisiveis(PAGINA_OPCOES);
        } else if (meta.action === 'menu-close' || meta.action === 'set-value') {
          setBusca('');
          setVisiveis(PAGINA_OPCOES);
        }
        return valor;
      }}
      onMenuScrollToBottom={() => setVisiveis((n) => n + PAGINA_OPCOES)}
    />
  );
};

export default SelectPaginado;
